import MuiBackdrop, { BackdropProps } from '@mui/material/Backdrop';
import { CircularProgress } from 'ui';

interface IBackdropProps extends BackdropProps {
  showSpinner?: boolean;
  size?: number | string;
}

const Backdrop = ({ showSpinner = false, size = 48, ...props }: IBackdropProps) => {
  return <MuiBackdrop {...props}>{showSpinner && <CircularProgress size={size} />}</MuiBackdrop>;
};

export default Backdrop;
